import Footer from "../../components/Footer";
import Navbar from "../../components/Navbar";
import Introduction from "../../components/Introduction";
import DefaultPage from "../DefaultPage/DefaultPage.js";
import useFetch from "../../hooks/useFetch";
import config from "../../config";
import { BlocksRenderer } from "@strapi/blocks-react-renderer";
import "../NewsDetailPage/NewsDetailPage.css";
import Document from "../DocumentsPage/Document.js";
import Loader from "../../components/Loader.js";

const SchoolCounselingPage = () => {
  //fetch stranky
  const { loading, error, data } = useFetch(
    `${config.api}/api/school-counseling-page?populate=*`
  );

  // možné stavy při/po fetchi
  if (loading) return <Loader />;
  if (error) return <DefaultPage message="Chyba při načítání stránky" />;

  if (!data || !data.data) return <DefaultPage message="Žádné data" />;

  //změna titulku stránky v prohlížeči
  document.title = data.data.title;

  const documents = Array.isArray(data.data.documents)
    ? data.data.documents
    : [];

  return (
    <div>
      <Navbar />
      <Introduction
        title={data.data.title}
        text={data.data.description}
        image={data.data.background.url}
      />
      <div className="container-fluid background-white">
        <div className="container container-background p-4 p-md-5 pt-md-4">
          <BlocksRenderer
            content={Array.isArray(data?.data?.text) ? data.data.text : []}
            blocks={{
              image: ({ image }) => (
                <img
                  src={image.url}
                  alt={image.alternativeText}
                  className="blocks-renderer-img"
                />
              ),
              list: ({ children, format }) =>
                format === "unordered" ? (
                  <ul className="blocks-renderer-ul">{children}</ul>
                ) : (
                  <ol className="blocks-renderer-ol">{children}</ol>
                ),
            }}
          ></BlocksRenderer>
          {documents.length > 0 && (
            <>
              <h3 className="mt-5">Ke stažení</h3>
              <div className="news-doc-container">
                {documents.map((doc) => (
                  <div key={doc.documentId ?? doc.id} className="news-doc">
                    <Document name={doc.name} fileUrl={doc.url} />
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
};
export default SchoolCounselingPage;
